export enum ServiceEnum {
  DoorToDoor = 'DOOR_TO_DOOR',
  SelfStorage = 'SELF_STORAGE',
  Moving = 'MOVING',
}
